// extracted by mini-css-extract-plugin
export default {"event":"wm9ss","desktopEvent":"NhEgh","name":"_3z6NO","desktopName":"ML4Un","date":"Mg134"};